module.exports = new __parcel__URL__("item_shop_tab_inactive.c170551f.png").toString();